import { T } from 'consts/translationKeys'
import { AI_VIDEO_IMAGE_MIME_TYPES } from 'consts/uploadTypes'
import { IMyFilesMediaItem } from 'types/media'
import { replaceTranslationVariables } from 'utils/text-transformation'
import { translate } from 'utils/translations'

export const validateImagesForAIVideo = (
  files: IMyFilesMediaItem[],
  supportedImageMimeTypes?: string[]
) => {
  const _supportedImageMimeTypes =
    supportedImageMimeTypes || AI_VIDEO_IMAGE_MIME_TYPES
  return files.filter(file =>
    _supportedImageMimeTypes.includes(
      file.mime as (typeof AI_VIDEO_IMAGE_MIME_TYPES)[number]
    )
  )
}

export const getSupportedFormatsLabel = (
  supportedImageMimeTypes?: string[]
) => {
  return supportedImageMimeTypes?.map(type => type.split('/').pop()).join(', ')
}

export const getImageReferencesTitle = (maxCount?: number) => {
  return `${translate(T.REFERENCES_LABEL)} ${
    maxCount
      ? `<(${replaceTranslationVariables(translate(T.UP_TO_FILES_LABEL), [
          maxCount.toString()
        ])})>`
      : ''
  }`
}
